module.exports = __webpack_public_path__ + "static/media/svg-sprite.c337e16d.svg";